import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import CoursesServices from "./Courses.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getCourse = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COURSE,
      payload: true,
    });
    const resp = await CoursesServices.getCourse(filters);
    dispatch({
      type: actions.GET_COURSE,
      payload: {
        courses: resp.data.data,
        coursesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.COURSE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COURSE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COURSE,
      payload: false,
    });
  }
};

export const getCourseById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COURSE,
      payload: true,
    });
    const resp = await CoursesServices.getCourseByID(id);
    dispatch({
      type: actions.GET_COURSE,
      payload: {
        courses: resp.data,
      },
    });
    dispatch({
      type: actions.COURSE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COURSE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COURSE,
      payload: false,
    });
  }
};

export const saveCourse =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_COURSE,
        payload: true,
      });
      const resp = await CoursesServices.saveCourse(data);
      const { courses, coursesLength } = getState().planCarreraCourse;
      const _courses = [...courses, resp.data];
      dispatch({
        type: actions.GET_COURSE,
        payload: {
          courses: _courses,
          coursesLength: coursesLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_COURSE,
        payload: false,
      });
    }
  };

export const editCourse =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_COURSE,
        payload: true,
      });
      const resp = await CoursesServices.editCourse(id, data);
      const { courses, coursesLength } = getState().planCarreraCourse;
      let _courses = [...courses]
      _courses[index] = resp.data;
      dispatch({
        type: actions.GET_COURSE,
        payload: {
          courses: _courses,
          coursesLength: coursesLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_COURSE,
        payload: false,
      });
    }
  };

export const deleteCourse = (id, index) => async (dispatch, getState) => {
  try {
   
    dispatch({
      type: actions.LOADING_COURSE,
      payload: true,
    });
    await CoursesServices.deleteCourse(id);
    const { courses, coursesLength } = getState().planCarreraCourse;
    let _courses = [...courses]
    _courses.splice(index, 1);
    dispatch({
      type: actions.GET_COURSE,
      payload: {
        courses: _courses,
        coursesLength: coursesLength - 1,
      },
    });
    dispatch({
      type: actions.COURSE_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;                         
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.COURSE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COURSE,
      payload: false,
    });
  }
};
